import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import srcVirtualAgentLandingQuery from '@atlassian/jira-relay/src/__generated__/srcVirtualAgentLandingQuery$parameters';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const landingEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() => {
		if (!__SERVER__) {
			return import(/* webpackChunkName: "async-virtual-agent-landing" */ './src');
		}
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		return Promise.resolve({ default: () => null }) as unknown as Promise<{
			default: typeof import('./src').default;
		}>;
	}),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: srcVirtualAgentLandingQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
				},
			},
		},
	}),
});
